import { createContext } from 'react';
import { DeviceDetailsState } from 'shared/providers/device-details/hooks/device-details-state';

const DeviceDetailsProviderContext = createContext({} as DeviceDetailsState);

export default DeviceDetailsProviderContext;
